module.exports = __webpack_public_path__ + "static/media/logo_login.7317363b.png";